import { render, staticRenderFns } from "./setBusinessIntranetExtend.vue?vue&type=template&id=018691cc&scoped=true"
import script from "./setBusinessIntranetExtend.vue?vue&type=script&lang=js"
export * from "./setBusinessIntranetExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018691cc",
  null
  
)

export default component.exports